import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const headingStyle = css`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	gap: 1.125rem;
	flex-wrap: wrap;
`;

const textStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	min-width: 0;
	max-width: 40rem;
`;

const eyebrowStyle = css`
	${theme.typography.eyebrow}
	margin: 0;
	text-transform: uppercase;
	color: ${theme.colors.inkMuted};
`;

const titleRowStyle = css`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	flex-wrap: wrap;
`;

const titleStyle = css`
	${theme.typography.pageTitle}
	margin: 0;
	color: ${theme.colors.ink};

	@media (max-width: ${theme.layout.compactBreakpoint}) {
		font-size: 2rem;
		line-height: 1.05;
	}
`;

const descriptionStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: 0.90625rem;
	line-height: 1.6;
	color: ${theme.colors.inkSecondary};
`;

type Props = {
	readonly eyebrow?: string;
	readonly title: string;
	readonly description?: string;
	/** A state chip set beside the title. */
	readonly chip?: React.ReactNode;
	readonly actions?: React.ReactNode;
};

/** Title block of the group screens: an optional monospace eyebrow, the title with its state chip, a description and a right-hand action. */
const ScreenHeading: React.FC<Props> = ({ eyebrow, title, description, chip, actions }) => {
	return (
		<header css={headingStyle}>
			<div css={textStyle}>
				<ConditionalLoader data={eyebrow}>
					{(eyebrowText) => <p css={eyebrowStyle}>{eyebrowText}</p>}
				</ConditionalLoader>
				<div css={titleRowStyle}>
					<h1 css={titleStyle}>{title}</h1>
					{chip}
				</div>
				<ConditionalLoader data={description}>
					{(descriptionText) => <p css={descriptionStyle}>{descriptionText}</p>}
				</ConditionalLoader>
			</div>
			{actions}
		</header>
	);
};

export default ScreenHeading;
